import Vue from "vue";
import VueI18n from "vue-i18n";

import * as EN from './LangUnion/en'
import * as PT from './LangUnion/pt'
import * as ES from './LangUnion/es'
import * as AR from './LangUnion/ar'
import * as TR from './LangUnion/tr'
import * as FR from './LangUnion/fr'
import * as ID from './LangUnion/id'
import * as DA from './LangUnion/da'
import * as DE from './LangUnion/de'
import * as IT from './LangUnion/it'
import Client from "@/assets/scripts/client";

Vue.use(VueI18n);

const messages = {
  'en': Object.assign(EN), // 英文
  'id': Object.assign(ID), // 印尼
  'pt': Object.assign(PT), // 葡萄牙语
  'es': Object.assign(ES), // 西班牙语
  'ar': Object.assign(AR), // 阿拉伯语
  'tr': Object.assign(TR), // 土耳其语
  'fr': Object.assign(FR), // 法语
  'da': Object.assign(DA), // 丹麦语
  'de': Object.assign(DE), // 德语
  'it': Object.assign(IT), // 意大利语
};

export function setI18nLanguage (lang) {
  i18n.locale = lang;
  document.querySelector('html').setAttribute('lang', lang);
  if (lang == 'ar') {
    document.querySelector('html').setAttribute('dir', 'rtl');
  } else {
    document.querySelector('html').removeAttribute('dir')
  }
  return lang;
}

export function getLanguage () {
  const chooseLanguage = Client.getAppInfoLang();
  if (chooseLanguage) {
    return chooseLanguage;
  }
  return '';
}

const i18n = new VueI18n({
  locale: getLanguage(),
  messages
});

export default i18n;
